<div *ngIf="message" class="alert-bar-container p-2">
  <div class="container inner-container d-flex">
    <span class="bulb-symbol">
      <svg-icon key="bulb"></svg-icon>
    </span>
    <b class="text-reduced-medium">{{ message }}</b>
  </div>
</div>
